import { render, staticRenderFns } from "./WaveformCanvas.vue?vue&type=template&id=879a605c&"
import script from "./WaveformCanvas.vue?vue&type=script&lang=ts&"
export * from "./WaveformCanvas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports